<ng-template #defaultItemTemplate let-item="item">
  {{item[labelKey]}}
</ng-template>
<ul
  #list
  [hidden]="hidden"
  class="dropdown-menu scrollable-menu"
  [class.mention-menu]="!styleOff"
  [class.mention-dropdown]="!styleOff && dropUp">
  <li *ngFor="let item of items; let i = index"
    [class.active]="activeIndex === i"
    [class.mention-active]="!styleOff && activeIndex === i">
    <a *ngIf="item.id > 0"
      class="dropdown-item"
      [class.mention-item]="!styleOff"
      (mousedown)="activeIndex = i;itemClick.emit();$event.preventDefault()">
      <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{'item':item}"></ng-template>
    </a>
    <span *ngIf="item.id === 0">{{item.label}}</span>
  </li>
</ul>
  